<template>
  <div class="app-jumbotron__container">
    <div class="app-jumbotron__content-container">
      <div class="app-jumbotron__content">
        <slot name="content" />
      </div>
      <div class="app-jumbotron__screenshot-container">
        <div class="app-jumbotron__screenshot">
          <slot name="screenshot" />
        </div>
        <div class="app-jumbotron__screenshot-caption">
          {{ screenshotCaption }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppJumbotron',
  props: {
    screenshotCaption: {
      type: String,
      default: 'Caption Goes Here'
    }
  }
}
</script>

<style scoped>
.app-jumbotron__container {
  display: flex;
  flex-direction: row;
  padding: 0;
  margin: 3rem 0 0 0;
  z-index: 10;
}

.app-jumbotron__content-container {
  background-color: rgba(51, 41, 36, 0.95);
  flex-shrink: 0;
  height: 23.44rem;
  display: flex;
  flex-direction: row;
}

.app-jumbotron__content {
  display: flex;
  height: 100%;
  width: calc(100% - 21.25rem);
  align-content: center;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 1rem;
}

.app-jumbotron__screenshot {
  box-shadow: 0 5px 10px 2px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  flex-grow: 0;
  box-sizing: content-box;
  align-content: center;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  z-index: 2;
  margin-top: -3.69rem;
  margin-left: auto;
  margin-right: 2rem;
  margin-bottom: 0;
  width: 21.25rem;
  height: 30.25rem;
  background: #fff;
  overflow: hidden;
}

.app-jumbotron__screenshot >>> div {
  flex-grow: 1;
  margin-right: 0;
}

.app-jumbotron__screenshot-caption {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  font-family: "Avenir-Heavy", "Avenir", "Helvetica", "sans-serif", "sans-serif";
  font-size: 1.125rem;
  color: #9b9b9b;
  letter-spacing: 0;
  align-self: flex-end;
  margin-bottom: -2.25rem;
  margin-top: 0.5rem;
  flex-shrink: 0;
  flex-grow: 0;
  text-align: center;
  width: 21.25rem;
}

/** Wide Screens */
@media screen and (min-width: 960px) {
  .app-jumbotron__container {
    box-sizing: border-box;
    justify-self: center;
  }

  .app-jumbotron__content-container {
    width: 60rem;
    border-radius: 0.625rem;
  }
}

/** Narrow screens */
@media screen and (max-width: 960px) {
  .app-jumbotron__container {
    box-sizing: border-box;
    width: 100%;
    height: 29rem;
    flex-direction: column;
  }

  .app-jumbotron__content-container {
    width: 100%;
  }

  .app-jumbotron__screenshot,
  .app-jumbotron__screenshot-caption {
    transform: scale(0.9);
  }

  .app-jumbotron__content {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    margin: 0;
    flex-shrink: 1;
    flex-direction: column;
    overflow: hidden;
    font-size: 0.5rem;
  }
}

@media screen and (max-width: 775px) {
  .app-jumbotron__content >>> .app-call-to-action__button_container {
    flex-direction: column;
  }

  .app-call-to-action__button_container >>> * {
    margin: 1rem 0;
  }

  .app-jumbotron__screenshot-caption {
    margin-top: -0.5rem;
  }
}

@media screen and (max-width: 600px) {
  .app-jumbotron__content-container {
    flex-direction: column;
    padding: 0;
    margin: 0;
    flex-grow: 0;
  }

  .app-jumbotron__content {
    flex-shrink: 0;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    flex-grow: 0;
  }

  .app-jumbotron__container {
    flex-direction: column;
    height: fit-content;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-top: 1rem;
    padding: 0;
  }

  .app-jumbotron__screenshot-container,
  .app-jumbotron__screenshot {
    margin-top: -2rem;
    margin-right: auto;
    margin-left: auto;
    z-index: auto;
  }
}
</style>
